/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Automix_Mix_HelpInputs */



/**
* | output |
* | --- |
* | "Balance between original and compressed audio (0-1)" |
*
* @param {Audio_Description_Export_Automix_Mix_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_mix_help = /** @type {((inputs?: Audio_Description_Export_Automix_Mix_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Mix_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Équilibre entre l'audio original et compressé (0-1)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verhältnis zwischen Original- und komprimiertem Audio (0-1)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Equilibrio tra audio originale e compresso (0-1)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Баланс между исходным и сжатым аудио (0-1)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Equilibrio entre audio original y comprimido (0-1)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("原始音频与压缩音频之间的平衡（0-1）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オリジナルオーディオと圧縮オーディオのバランス（0-1）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मूल और संपीड़ित ऑडियो के बीच संतुलन (0-1)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Equilíbrio entre áudio original e comprimido (0-1)")
	return /** @type {LocalizedString} */ ("Balance between original and compressed audio (0-1)")
});